import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'fl-scrollable-content',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./scrollable-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollableContentComponent {
  /** To use when the content could be wider than the container */
  @HostBinding('attr.data-hide-horizontal-scroll')
  @Input()
  hideHorizontalScroll = false;

  /** To use when the content could be higher than the container */
  @HostBinding('attr.data-hide-vertical-scroll')
  @Input()
  hideVerticalScroll = false;

  /** To use when the container needs to be adjust to the height of the content, instead of push 100% of the height of the parent container */
  @HostBinding('attr.data-auto-height')
  @Input()
  autoHeight = false;

  constructor(private element: ElementRef<HTMLElement>) {}

  scrollToBottom() {
    // Use timeout to trigger scroll to the bottom after the view is updated
    setTimeout(
      () =>
        (this.element.nativeElement.scrollTop = this.element.nativeElement.scrollHeight),
      0,
    );
  }

  // scrollTop is the Y position of the current view in the entire scrollable content
  // offsetHeight is the height of the current view port
  // scrollHeight is the total height of the scrollable content.
  // offset is the height of a single message, to keep the same logic as before
  isAtBottom(offset: number = 0) {
    return (
      this.element.nativeElement.scrollTop +
        this.element.nativeElement.offsetHeight +
        offset >=
      this.element.nativeElement.scrollHeight
    );
  }

  getScrollHeight() {
    const { scrollHeight } = this.element.nativeElement;
    return scrollHeight;
  }
}
